function isInitialism(segment) {
  return /^[A-Z]{2,}$/.test(segment); // e.g., "AJ", "JD"
}

function capitalizeSegment(segment) {
  if (segment.length === 0) return "";

  // Preserve known initialisms like "AJ"
  if (isInitialism(segment)) {
    return segment;
  }

  // Handle McX or MacX
  if (/^mc[a-z]/i.test(segment)) {
    return (
      "Mc" + segment.charAt(2).toUpperCase() + segment.slice(3).toLowerCase()
    );
  }
  if (/^mac[a-z]/i.test(segment)) {
    return (
      "Mac" + segment.charAt(3).toUpperCase() + segment.slice(4).toLowerCase()
    );
  }

  return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
}

function capitalizeName(name) {
  return name
    .split(" ")
    .map((word) =>
      word
        .split(/([-'])/) // split by apostrophe/hyphen and keep them
        .map((part) => (/[-']/.test(part) ? part : capitalizeSegment(part)))
        .join(""),
    )
    .join(" ");
}

export { capitalizeName };
